import { MemberStatus } from '../enums/member-status.enum'
import type { WorkspaceMember } from '../types/workspace-member.type'

import { InviteEmailConflict } from './invite-email-conflict.enum'
import { normalizeInviteEmail } from './normalizeInviteEmail'

export const findInviteEmailConflict = (members: WorkspaceMember[], email: string): InviteEmailConflict | null => {
  const normalizedEmail = normalizeInviteEmail(email)
  if (!normalizedEmail) {
    return null
  }

  const existingMember = members.find((member) => normalizeInviteEmail(member.email) === normalizedEmail)
  if (!existingMember) {
    return null
  }

  if (existingMember.status === MemberStatus.PENDING) {
    return InviteEmailConflict.ALREADY_INVITED
  }

  return InviteEmailConflict.ALREADY_MEMBER
}
